import Widget from "csi/datasheet/Widget";
import declare from "dojo/_base/declare";

const TDSViewController = declare(Widget, {

	/** @property {boolean} disableCustomViewToolbar - remove CustomViewToolbar from view. */
	// Note that we need to overide supportsCustomViews() for custom views to work normally.
	disableCustomViewToolbar: true,

	/** @property {boolean} stateChanged - indicates if the current node's revision has changed */
	stateChanged: false,

	// Hide toolbars toggle button
	plugins: ["print", "pdf", "refresh"],

	onViewPlugins(): void {
		// on fresh load of Approved revision node, set plugins to only print
		if (this.getViewNode()?.State === "Revision.State:APPROVED" && !this.stateChanged) {
			this.plugins = ["print"];
		}
	},

	/**
	 * @override
	 * Always return true so CustomView is enabled even though toolbar is disabled
	 */
	supportsCustomViews(): boolean {
		return true;
	},

	/**
	 * @override
	 * Use SPRevision.TDSCustomView for urlDefaultView
	 */
	refreshCustomViewStore(bResetStore) {
		const tdsCustomView = this.getViewNode()?.TDSCustomView;
		if (tdsCustomView) {
			this.urlDefaultView = tdsCustomView;
		}
		return this.inherited(arguments);
	},

});

export = TDSViewController;
